export default __webpack_public_path__ + "static/media/SndLowerBAroundBump.c05b2567.mp3";